import { useAuth } from '../context/AuthContext';

/**
 * Returns true when the named partner-level feature flag is enabled for the
 * currently authenticated partner. Partner features are loaded once at app
 * start as part of the partner auth context (see PartnerAuthController).
 *
 * Missing key (or no auth context yet) is treated as OFF.
 */
export function usePartnerFeature(featureKey: string): boolean {
  const { partnerAuthContext } = useAuth();
  return partnerAuthContext?.partnerFeatures?.[featureKey] === true;
}

/**
 * Returns whether partner features have been successfully loaded.
 * Use this to distinguish "feature is disabled" from "features failed to load"
 * (e.g. due to a 500 from the feature endpoint during auth context init).
 */
export function usePartnerFeaturesLoaded(): boolean {
  const { partnerAuthContext, isLoading } = useAuth();
  return !isLoading && partnerAuthContext?.partnerFeatures !== undefined;
}
